import { CANDIDATES_OFFER_STATUS, CONTRACTS } from "@core/constants";
import {
  ICandidateEtab,
  IEtabCategory,
  ICandidateDashboardOffer,
  IQualification,
  ICandidateOfferSalary,
  ICandidateOfferAddress,
  ICandidateOfferScheduleDay,
} from "@core/models";

export const candidateTemporaryOffersMock = [
  {
    [ICandidateDashboardOffer.id]: 34441049889001,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:36",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Bar des amis",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café Hôtel Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 10,
    [ICandidateDashboardOffer.firstShift]: {
      [ICandidateOfferScheduleDay.date]: "2022-09-07",
      [ICandidateOfferScheduleDay.startHour]: 1170,
      [ICandidateOfferScheduleDay.endHour]: 1620,
      [ICandidateOfferScheduleDay.breakBuration]: 60,
    },
  },
  {
    [ICandidateDashboardOffer.id]: 344343692250001,
    [ICandidateDashboardOffer.startDate]: "2022-08-23",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:05:48",
    [ICandidateDashboardOffer.schedule]: "111h15",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Bricktop Pizza (Canal Saint-Martin) -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 42,
        [IEtabCategory.name]: "Pizzeria",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/bf/96/d4/bf96d4b69090bfdf3d24447f415aa4e3.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 2850,
      [ICandidateOfferSalary.amount]: 25.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "69001",
      [ICandidateOfferAddress.city]: "Lyon",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 20,
    [ICandidateDashboardOffer.firstShift]: {
      [ICandidateOfferScheduleDay.date]: "2022-08-23",
      [ICandidateOfferScheduleDay.startHour]: 1170,
      [ICandidateOfferScheduleDay.endHour]: 1620,
      [ICandidateOfferScheduleDay.breakBuration]: 60,
    },
  },
  {
    [ICandidateDashboardOffer.id]: 34433812532251,
    [ICandidateDashboardOffer.startDate]: "2022-08-29",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:03:24",
    [ICandidateDashboardOffer.schedule]: "28h15",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café Montparnasse -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 25,
        [IEtabCategory.name]: "Brasserie",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/23/55/0e/23550e81e178e7440505e383642e9f24.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 350.25,
      [ICandidateOfferSalary.amount]: 12.75,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75014",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 1,
  },
  {
    [ICandidateDashboardOffer.id]: 34424349444001,
    [ICandidateDashboardOffer.startDate]: "2022-08-30",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-19 15:48:35",
    [ICandidateDashboardOffer.schedule]: "34h",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Responsable point de vente / Administrateur hôtellerie",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Le Restaurant Du Bac à Sable d'Aulnay-sous-bois la vérité c'est long comme nom",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 33,
        [IEtabCategory.name]: "Salle de concert",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 750,
      [ICandidateOfferSalary.amount]: 22,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "06000",
      [ICandidateOfferAddress.city]: "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 5,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
  },
  {
    [ICandidateDashboardOffer.id]: 34439936400001,
    [ICandidateDashboardOffer.startDate]: "2022-08-31",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:56:14",
    [ICandidateDashboardOffer.schedule]: "130h",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 55,
      [IQualification.qualificationLabel]: "Veilleur de nuit",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Brasserie du palace",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Restaurant Gastronomique",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/d5/b7/cc/d5b7cc26401bd97d348bc28b8e69418d.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1337,
      [ICandidateOfferSalary.amount]: 10.22,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75013",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 8,
  },
  {
    [ICandidateDashboardOffer.id]: 34439936400001,
    [ICandidateDashboardOffer.startDate]: "2022-08-31",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:56:14",
    [ICandidateDashboardOffer.schedule]: "130h",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 50,
      [IQualification.qualificationLabel]: "Pizzaiolo",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Restaurant Pisolini",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Restaurant Italien",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/d5/b7/cc/d5b7cc26401bd97d348bc28b8e69418d.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1337,
      [ICandidateOfferSalary.amount]: 10.22,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75013",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.INTERIM,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 8,
    [ICandidateDashboardOffer.firstShift]: {
      [ICandidateOfferScheduleDay.date]: "2022-08-31",
      [ICandidateOfferScheduleDay.startHour]: 1170,
      [ICandidateOfferScheduleDay.endHour]: 1620,
      [ICandidateOfferScheduleDay.breakBuration]: 60,
    },
  },
];

export const candidateTemporaryOffersSelectedMock = [
  {
    [ICandidateDashboardOffer.id]: 344243494440001,
    [ICandidateDashboardOffer.startDate]: "2022-08-30",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-19 15:48:35",
    [ICandidateDashboardOffer.schedule]: "34h",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Responsable point de vente / Administrateur hôtellerie",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Le Restaurant Du Bac à Sable d'Aulnay-sous-bois la vérité c'est long comme nom",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 33,
        [IEtabCategory.name]: "Salle de concert",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 750,
      [ICandidateOfferSalary.amount]: 22,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "06000",
      [ICandidateOfferAddress.city]: "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 5,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142252,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142253,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142254,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142255,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142256,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142257,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142258,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142262,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142260,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142263,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142265,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225111,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225122,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225134,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251656,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251878,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225154,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225132,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225115,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225128,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225198,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422510989,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251074,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422510773,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422515453,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225111324,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225154332,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422513232,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225110978,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422513232,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251121212,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225165656,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225186878,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225197897,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422517654,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251223,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422517649,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251564322,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422519812,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225132186,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422516589,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251664467,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251222222,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251111111,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 344404931422513333,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 3444049314225144444,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 12,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
];

export const candidateTemporaryOffersRefusedMock = [
  {
    [ICandidateDashboardOffer.id]: 34441049889001,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:36",
    [ICandidateDashboardOffer.schedule]: "80h30",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Bar des amis",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café Hôtel Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 10,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.REFUSED,
  },
  {
    [ICandidateDashboardOffer.id]: 34434369225001,
    [ICandidateDashboardOffer.startDate]: "2022-08-23",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:05:48",
    [ICandidateDashboardOffer.schedule]: "111h15",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Bricktop Pizza (Canal Saint-Martin) -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 42,
        [IEtabCategory.name]: "Pizzeria",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/bf/96/d4/bf96d4b69090bfdf3d24447f415aa4e3.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 2850,
      [ICandidateOfferSalary.amount]: 25.5,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "69001",
      [ICandidateOfferAddress.city]: "Lyon",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 20,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.REFUSED,
  },
];

export const candidateTemporaryOffersAppliedMock = [
  {
    [ICandidateDashboardOffer.id]: 3443381253225112,
    [ICandidateDashboardOffer.startDate]: "2022-08-29",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:03:24",
    [ICandidateDashboardOffer.schedule]: "28h15",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café Montparnasse -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 25,
        [IEtabCategory.name]: "Brasserie",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/23/55/0e/23550e81e178e7440505e383642e9f24.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 350.25,
      [ICandidateOfferSalary.amount]: 12.75,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75014",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 1,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.APPLIED,
  },
  {
    [ICandidateDashboardOffer.id]: 3442434944400001,
    [ICandidateDashboardOffer.startDate]: "2022-08-30",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-19 15:48:35",
    [ICandidateDashboardOffer.schedule]: "34h",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Responsable point de vente / Administrateur hôtellerie",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Le Restaurant Du Bac à Sable d'Aulnay-sous-bois la vérité c'est long comme nom",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 33,
        [IEtabCategory.name]: "Salle de concert",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.forecast]: 750,
      [ICandidateOfferSalary.amount]: 22,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "06000",
      [ICandidateOfferAddress.city]: "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.AE,
    [ICandidateDashboardOffer.isBookingExpress]: false,
    [ICandidateDashboardOffer.nbDays]: 5,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.APPLIED,
  },
];
